//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameStatus, BetStatus, WHEEL_MULTIPLIERS, Multiplier } from '../wheel.entity';

export default {
  name: 'WheelSidebarBet',
  props: {
    bet: {
      type: Object,
      required: true,
      default: () => ({ color: 2, winItemPrice: 0, itemsTotal: 0 })
    },
    gameStatus: {
      type: Number,
      required: true
    },
    winColor: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      BetStatus,
      GameStatus,
      WHEEL_MULTIPLIERS,
      Multiplier
    };
  },
  computed: {
    isWon() {
      return this.bet.color === this.winColor && this.gameStatus === GameStatus.ENDED;
    }
  },
  methods: {
    formatCurrency(val) {
      if (val === undefined || val === null) return '$0.00';
      return `$${Number(val).toFixed(2)}`;
    }
  }
};
